export default __webpack_public_path__ + "static/media/macagram.5a655f50.JPG";